export type MorphScheme = "LEGACY" | "MULTI_MESH";

const MULTI_MESH_SENTINELS = ["Head_o", "Teeth_MouthOpen", "Head_Ch"];

export function detectMorphScheme(object: any): MorphScheme {
    if (!object || typeof object.traverse !== "function") return "LEGACY";

    const keys = new Set<string>();
    object.traverse((child: any) => {
        if (child.isMesh && child.morphTargetDictionary) {
            for (const name of Object.keys(child.morphTargetDictionary)) {
                keys.add(name);
            }
        }
    });

    for (const sentinel of MULTI_MESH_SENTINELS) {
        if (keys.has(sentinel)) return "MULTI_MESH";
    }
    return "LEGACY";
}
